module.exports = __webpack_public_path__ + "img/6.1799572f.jpg";